import React, { useState, useMemo } from 'react';
import { useLogo } from '../contexts/LogoContext';

const Logo = ({ 
  size = '2rem', 
  style = {}, 
  showFallback = true,
  className = ''
}) => {
  const { logoUrl, loading } = useLogo();
  const [imageError, setImageError] = useState(false);

  // Memoize the cache buster to prevent constant regeneration
  const cacheBuster = useMemo(() => Date.now(), [logoUrl]);

  const handleImageError = () => {
    setImageError(true);
  };

  const logoStyle = {
    fontSize: size,
    display: 'inline-block',
    ...style
  };

  const imageStyle = {
    width: size,
    height: size,
    objectFit: 'contain',
    borderRadius: '8px',
    ...style
  };

  // 如果有自定义logo且没有错误，显示图片
  if (logoUrl && !imageError && !loading) {
    return (
      <img
        src={logoUrl + '?' + cacheBuster} // Cache buster (memoized)
        alt="S.U.E. Logo"
        style={imageStyle}
        className={className}
        onError={handleImageError}
      />
    );
  }

  // 在loading状态或没有logo时，显示默认emoji (如果允许fallback)
  if (showFallback) {
    return (
      <span style={logoStyle} className={className}>
        🤖
      </span>
    );
  }

  // 不显示fallback的情况下，如果没有logo就返回null
  return null;
};

export default Logo; 